import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import Button from 'sushiweb/Button/Button';
import { P } from 'sushiweb/Typography/Text';
import {
  FOOD_AT_WORK_IMG,
  FOOD_AT_WORK_LOGO_IMG,
} from '../../constants/images';
import { LOGIN_CAPTION } from './constants';
import { Container, ZLogoWrapper, ZImageWrapper } from './styles';
import { openErrorToast } from '../../reducers/uiLogic';
import { authCheckInitiate, signIn } from '../../actions/auth';

const Login = ({ showErrorToast, dispatchToAuthenticate }) => {
  const onLoginClick = () => {
    // Auth.login('IFRAME', 'login_ui')
    //   .then(res => {
    //     console.log(res);
    //     dispatchToAuthenticate();
    //   })
    //   .catch(err => {
    //     console.log(err);
    //     showErrorToast();
    //   });

    if (window.zoauth !== undefined) {
      signIn()
        .then(res => {
          console.log(res);
          dispatchToAuthenticate();
        })
        .catch(err => {
          console.log(err);
          showErrorToast();
        });
    }
  };

  return (
    <>
      <Container>
        <ZLogoWrapper
          width='28.8rem'
          height='8.8rem'
          src={FOOD_AT_WORK_LOGO_IMG}
          alt='food-at-work'
        />
        <P>{LOGIN_CAPTION}</P>
        <ZImageWrapper
          width='45rem'
          height='28.4rem'
          src={FOOD_AT_WORK_IMG}
          alt='food-at-work'
        />
        <Button size='large' btnColor='red' onClick={onLoginClick}>
          Login
        </Button>
        {/* <Auth isOpen={isOpen} loginType='login' closeModal={closeModal} /> */}
      </Container>
    </>
  );
};

Login.propTypes = {
  showErrorToast: PropTypes.func,
  dispatchToAuthenticate: PropTypes.func,
};

Login.defaultProps = {
  showErrorToast: _noop,
  dispatchToAuthenticate: _noop,
};

const mapDispatchToProps = dispatch => ({
  showErrorToast: payload => dispatch(openErrorToast(payload)),
  dispatchToAuthenticate: () => dispatch(authCheckInitiate()),
});

export default connect(
  null,
  mapDispatchToProps,
)(Login);
